/**
 * The datapoints an approval would publish (ESG-4012), as the uid list the "Manage changed data" pre-flight is
 * asked about.
 *
 * Computed here from the three lists rather than read off the response: the server's `datapointUids()` is a
 * convenience on the Java record, not a component, so it never reaches the wire. Removed figures are included —
 * approving a deletion strands an answer built on that figure as surely as approving an edit does.
 *
 * @param {{added?: Array, edited?: Array, removed?: Array}|null|undefined} pending
 * @returns {string[]} distinct, non-blank uids
 */
export function pendingDatapointUids(pending) {
  const all = [...(pending?.added ?? []), ...(pending?.edited ?? []), ...(pending?.removed ?? [])];
  return [...new Set(all.map((change) => change?.datapointUid).filter((uid) => !!uid && String(uid).trim() !== ""))];
}

/** How many changes are waiting, across all three kinds. */
export function pendingChangeCount(pending) {
  return (pending?.added?.length ?? 0) + (pending?.edited?.length ?? 0) + (pending?.removed?.length ?? 0);
}
